import { ListGroup, Badge } from "react-bootstrap";
import {FaRegHandshake, FaHome, FaHeadset, FaBell, FaFileMedical, FaUserInjured, FaUserMd, FaFileContract, FaMoneyCheck, FaCoins, FaChartBar, FaFileMedicalAlt, FaCalendarAlt, FaDollarSign, FaTeamspeak, FaRobot, FaMapMarkedAlt, FaTicketAlt } from "react-icons/fa";
import { TbTicket } from "react-icons/tb";
import { getCurrentUser, hasPerm } from '../../common/utils';
import { getConfig } from "../../common/config";
import { useTranslation } from 'react-i18next';


const MenuOperador = ({
  pathname,
  search,
  noDashboard,
  ocultar_receptivos,
  ocultar_atendimentos,
  ocultar_prestadores,
  gestao_aplicacoes,
  menus_adicionais,
  faturamentosPendentes,
  ambiente_programa_id,
  showSuporteMenu,
  habilitar_indicacao_profissional,
  habilitar_vouchers,
}) => {

  const { t } = useTranslation(['menu']);
  const dados_usuario = getCurrentUser();
  const configuracoes_programa = localStorage.getItem(`programa_configuracoes_${dados_usuario['ambiente_programa_id']}`);
  const podeVisualizarFluxoCeaf = hasPerm("view_ceaf_estado") || hasPerm("view_chamados") || dados_usuario?.tipo_usuario === 'operador';
  const podeVisualizarHistoricoCeaf = hasPerm("view_ceaf_auditoria_chatbot");

  return (
    <>
        {noDashboard === false && (
            <ListGroup variant="flush">
            <ListGroup.Item action href="/home" className="itemMenu" active={pathname.indexOf("/home") !== -1 || pathname === "/"} >
                <FaHome /> {t('menu:item.home')}
            </ListGroup.Item>
            </ListGroup>
        )}

        <div className="list-divider">
            <p>{t('menu:section.patientCare')}</p>
        </div>

        {hasPerm("view_agendamentos") && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/agendas" className="itemMenu" active={pathname === "/agendas" || pathname === "/agendas/" || (pathname === "/" && noDashboard)}>
              <FaCalendarAlt /> {t('menu:item.schedule')}
            </ListGroup.Item>
          </ListGroup>
        )}

        {/* A operação só tinha a Agenda (calendário). A listagem de agendamentos existe e
            ela já tem a permissão — faltava o item no menu, então só chegava lá por dentro
            do atendimento. */}
        {hasPerm("view_agendamentos") && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/agendamentos" className="itemMenu" active={pathname.indexOf("/agendamentos") !== -1}>
              <FaCalendarAlt /> {t('menu:item.appointments')}
            </ListGroup.Item>
          </ListGroup>
        )}

        {hasPerm("view_atendimentos") && (
            <>
                {!ocultar_atendimentos && (
                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/atendimentos" className="itemMenu" active={pathname === "/atendimentos" || pathname === "/atendimentos/" || (pathname === "/" && noDashboard)} >
                            <FaHeadset /> {t('menu:item.encounters')}
                        </ListGroup.Item>
                    </ListGroup>
                )}

                {Array.isArray(menus_adicionais) && menus_adicionais.length > 0 && (
                    <ListGroup variant="flush">
                        {menus_adicionais.map((menu) => (
                            <ListGroup.Item key={menu.id} action href={`/atendimentos-receptivo/?status=${menu.id}`} className="itemMenu" active={search === `?status=${menu.id}`} >
                                <FaHeadset /> {menu.menu_adicional_atendimento}
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                )}
            </>
        )}

        {!ocultar_atendimentos && hasPerm("view_autorizacoes") && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/autorizacoes" className="itemMenu" active={pathname.indexOf("/autorizacoes") !== -1}>
              <FaFileContract /> {t('menu:item.authorizations')}
            </ListGroup.Item>
          </ListGroup>
        )}

        {!ocultar_atendimentos && hasPerm("view_viewatendimentoscompliance") && gestao_aplicacoes && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/compliance" className="itemMenu" active={pathname.indexOf("/compliance") !== -1} >
              <FaFileContract /> {t('menu:item.therapyCompliance')}
            </ListGroup.Item>
          </ListGroup>
        )}

        {getConfig(configuracoes_programa, 'agendamento.despesas', false) === true && hasPerm("view_agendamentos_despesas") && (
          <ListGroup variant="flush">
              <ListGroup.Item action href="/despesas" className="itemMenu" active={pathname === "/despesas"} >
                  <FaDollarSign /> {t('menu:item.appointmentExpenses')}
              </ListGroup.Item>
          </ListGroup>
        )}

        {!ocultar_atendimentos && hasPerm("view_exames") && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/exames" className="itemMenu" active={pathname.indexOf("/exames") !== -1} >
              <FaFileMedical /> {t('menu:item.exams')}
            </ListGroup.Item>
          </ListGroup>
        )}

        {hasPerm("view_atendimentos") && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/farmacovigilancia" className="itemMenu" active={pathname.indexOf("/farmacovigilancia") !== -1} >
              <FaFileMedical /> {t('menu:item.pharmacovigilance')}
            </ListGroup.Item>
          </ListGroup>
        )}

        {hasPerm("view_atendimentos") && (
          <>
            {!ocultar_receptivos && (
              <ListGroup variant="flush">
                  <ListGroup.Item action href="/atendimentos-receptivo" className="itemMenu" active={pathname === "/atendimentos-receptivo" || (pathname === "/atendimentos-receptivo/" && !(search || "").includes("status")) } >
                      <FaHeadset /> {t('menu:item.inboundCalls')}
                  </ListGroup.Item>
              </ListGroup>
            )}
          </>
        )}
               
        {!ocultar_atendimentos && hasPerm("pode_gerar_relatorio") && (
            <ListGroup variant="flush">
                <ListGroup.Item action href="/relatorios" className="itemMenu" active={pathname.indexOf("/relatorios") !== -1} >
                <FaChartBar /> {t('menu:item.reports')}
                </ListGroup.Item>
            </ListGroup>
        )}

        {!ocultar_atendimentos && hasPerm('view_farmacovigilancia') && (
            <ListGroup variant="flush">   
                <ListGroup.Item 
                    action 
                    href="/reportes-farmaco"
                    className="itemMenu" 
                    active={pathname.indexOf("/reportes-farmaco") !== -1}
                >
                    <FaFileMedicalAlt /> {t('menu:item.pvReports')}
                </ListGroup.Item>      
            </ListGroup>
        )}   

        {((hasPerm("view_atendimentos") && hasPerm("view_faturamentos")) || getConfig(configuracoes_programa, 'agendamento.despesas', false) === true) && (
          <>
            <div className="list-divider">
              <p>{t('menu:section.financial')}</p>
            </div>
          
            <ListGroup variant="flush">
                <ListGroup.Item action href="/extratoservicos" className="itemMenu" active={pathname === "/extratoservicos"} >
                    <FaMoneyCheck /> {t('menu:item.serviceStatement')}
                </ListGroup.Item>
            </ListGroup>

            <ListGroup variant="flush">
              <ListGroup.Item action href="/faturamentos" className="itemMenu" active={pathname.indexOf("/faturamentos") !== -1} >
                <FaCoins /> {t('menu:item.billing')}
                {faturamentosPendentes > 0 && (
                  <Badge pill bg="danger" className="ms-2">
                    {faturamentosPendentes}
                  </Badge>
                )}
              </ListGroup.Item>
            </ListGroup>
          </>
        )}

        <div className="list-divider">
            <p>{t('menu:section.programsAndPatients')}</p>
        </div>

        {hasPerm("view_prestadores") && !ocultar_prestadores && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/medicos" className="itemMenu" active={pathname.indexOf("/medicos") !== -1} >
              <FaUserMd /> {t('menu:item.doctors')}
            </ListGroup.Item>
          </ListGroup>
        )}

        {hasPerm("view_beneficiarios") && hasPerm("add_beneficiarios") && (
            <ListGroup variant="flush">
              <ListGroup.Item action href="/pacientes" className="itemMenu" active={pathname.indexOf("/pacientes") !== -1} >
                <FaUserInjured /> {t('menu:item.patients')}
              </ListGroup.Item>
            </ListGroup>
        )}

        {hasPerm("view_prestadores") && !ocultar_prestadores && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/prestadores" className="itemMenu" active={pathname.indexOf("/prestadores") !== -1} >
              <FaUserMd /> {t('menu:item.providers')}
            </ListGroup.Item>
          </ListGroup>
        )}

        {/* so em programa que oferece indicacao: a fila nao existe nos demais */}
        {hasPerm("view_prestadores") && habilitar_indicacao_profissional && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/indicacoes-recebidas" className="itemMenu" active={pathname.indexOf("/indicacoes-recebidas") !== -1} >
              <FaRegHandshake /> Indicações Recebidas
            </ListGroup.Item>
          </ListGroup>
        )}

        {hasPerm("view_vouchers") && habilitar_vouchers && (
          <ListGroup variant="flush">
            <ListGroup.Item action href="/vouchers" className="itemMenu" active={pathname.indexOf("/vouchers") !== -1} >
              <FaTicketAlt /> Vouchers
            </ListGroup.Item>
          </ListGroup>
        )}

      {(podeVisualizarFluxoCeaf || podeVisualizarHistoricoCeaf) && (
        <>
          <div className="list-divider">
            <p>{t('menu:section.ceaf')}</p>
          </div>
          <ListGroup variant="flush">
            {podeVisualizarFluxoCeaf && (
              <ListGroup.Item action href="/fluxo-ceaf" className="itemMenu" active={pathname.indexOf("/fluxo-ceaf") !== -1}>
                <FaMapMarkedAlt /> {t('menu:item.ceafFlow')}
              </ListGroup.Item>
            )}
            {podeVisualizarHistoricoCeaf && (
              <ListGroup.Item action href="/historico-chatbot" className="itemMenu" active={pathname.indexOf("/historico-chatbot") !== -1}>
                <FaRobot /> {t('menu:item.chatbotHistory')}
              </ListGroup.Item>
            )}
          </ListGroup>
        </>
      )}

      {hasPerm("view_chamados") && showSuporteMenu && (
        <>
          <div className="list-divider">
              <p>{t('menu:section.support')}</p>
          </div>
          <ListGroup variant="flush">
            <ListGroup.Item action href="/chamados" className="itemMenu" active={pathname.indexOf("/chamados") !== -1} >
              <TbTicket /> {t('menu:item.tickets')}
            </ListGroup.Item>

            <ListGroup.Item action href="/notificacoes" className="itemMenu" active={pathname.indexOf("/notificacoes") !== -1} >
                <FaBell /> {t('menu:item.notifications')}
            </ListGroup.Item>

            {getConfig(configuracoes_programa, 'ativar_faq', false) === true && (
              <ListGroup.Item action href="/faq" className="itemMenu" active={pathname.indexOf("/faq") !== -1}>
                <FaTeamspeak /> {t('menu:item.faq')}
              </ListGroup.Item>
            )}
          </ListGroup>

        </>
      )}
    </>
  );
};

export default MenuOperador;
